export class ParametreOperationDto {
	cle: string;
	valeur: string;

	constructor(cle: string, valeur: string) {
		this.cle = cle;
		this.valeur = valeur;
	}

	deserialize(input: any): ParametreOperationDto {
		Object.assign(this, input);
		return this;
	}
}
